import { IndexedFilters } from '../types/filters';

export function injectMakeModelFilters(
  baseFilters: IndexedFilters,
  make?: string,
  model?: string
): IndexedFilters {
  if (!make) return baseFilters;

  return {
    ...baseFilters,
    makes: {
      [make]: model ? [model] : [],
    },
  };
}
